import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQrScanLine = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_10446_156502)",
		children: /* @__PURE__ */ _jsx("path", { d: "M21 16V21H3V16H5V19H19V16H21ZM3 11H21V13H3V11ZM21 8H19V5H5V8H3V3H21V8Z" })
	})
});
export default SvgQrScanLine;
